import { IPosition, IPositionBillingRate } from './../views/settings/types/department';
import { IDepartment } from '../views/settings/types/department'
import { _employeesWithCostRate } from './employeeFixtures';

export const _initialDepartments: IDepartment[] = [
  { id: '', name: '', hourly_rate: '' }
]

export const _departments: IDepartment[] = [
  { id: 1, name: 'Department Test One', hourly_rate: '2'  },
  { id: 2, name: 'Department Test Two', hourly_rate: '5'  },
  { id: 3, name: 'Department Test Three', hourly_rate: '33'  }
]

export const _positions: IPosition[] = [
  { id: 1, name: 'Position Test One' },
  { id: 2, name: 'Position Test Two' },
  { id: 3, name: 'Position Test Three' }
]

export const _departmentWithPositions: IDepartment = { id: 1, name: 'Department Test One', hourly_rate: '2', positions: _positions  }

export const _departmentWithEmployees: IDepartment[] = [{ id: 1, name: 'Department Test One', hourly_rate: '2', positions: _positions, employees: _employeesWithCostRate  }]

export const _initialPositionFitures: IPosition = { id: '', name: '' }

export const _initialPositionBillingRateFixtures: IPositionBillingRate = {
  id: '',
  position_id: _initialPositionFitures.id,
  billing_rate: 0,
  start_date:  null,
  end_date:  null,
  position_name: _initialPositionFitures.name
}
